export class TimeEntryPresentTemplate {
    activate(params) {
        this.presences = params.data;
    }
}